/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BattleFieldDto } from '../model/battleFieldDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BattleFieldService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get BattleField
     * Get BattleField
     * @param boardId Board ID
     * @param visiblePrivate Show current user private information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBattleField(boardId: number, visiblePrivate?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BattleFieldDto>;
    public getBattleField(boardId: number, visiblePrivate?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BattleFieldDto>>;
    public getBattleField(boardId: number, visiblePrivate?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BattleFieldDto>>;
    public getBattleField(boardId: number, visiblePrivate?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (boardId === null || boardId === undefined) {
            throw new Error('Required parameter boardId was null or undefined when calling getBattleField.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (visiblePrivate !== undefined && visiblePrivate !== null) {
            queryParameters = queryParameters.set('visiblePrivate', <any>visiblePrivate);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BattleFieldDto>('get',`${this.basePath}/api/battle-fields/${encodeURIComponent(String(boardId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
